export function hasNavigator() {
  try {
    return !!window.Navigator;
  } catch (e) {
    return false;
  }
}

export function hasSendBeacon() {
  try {
    return !!(hasNavigator() && window.Navigator.prototype.sendBeacon);
  } catch (e) {
    return false;
  }
}
